class UIMessagesContainer {
  constructor($interval, uimessages) {
    'ngInject';

    this.$interval = $interval;
    this.uimessages = uimessages;
    this.unsubscribers = [];

    this.notificationsFreshnessTime = 1200;
    this.notificationsExpirationDelayTime = 1200;
    this.notifications = [];

    this.showAlert = false;
    this.alertInfo = {};

    this.showConfirm = false;
    this.confirmInfo = {};

    this.addNotification = this.addNotification.bind(this);
    this.closeNotification = this.closeNotification.bind(this);
    this.openAlert = this.openAlert.bind(this);
    this.openConfirm = this.openConfirm.bind(this);
  }
  $onInit() {
    this.unsubscribers = [
      this.uimessages.onNewNotification(this.addNotification),
      this.uimessages.onExpiredNotification(this.closeNotification),
      this.uimessages.onNewAlert(this.openAlert),
      this.uimessages.onNewConfirm(this.openConfirm),
    ];
  }
  $onDestroy() {
    this.unsubscribers.forEach((fn) => fn());
  }
  addNotification(notification) {
    const newNotification = Object.assign({}, notification, {
      new: true,
      expired: false,
    });

    this.notifications.push(newNotification);

    let timer = this.$interval(() => {
      this._notificationById(newNotification.id).new = false;
      this.$interval.cancel(timer);
      timer = null;
    }, this.notificationsFreshness);
  }
  closeNotification(notification) {
    const expiredNotification = this._notificationById(notification.id);
    /**
     * We need this check because it's possible the user manually closed the
     * notification before the expiration time.
     */
    if (expiredNotification) {
      expiredNotification.expired = true;
      let timer = this.$interval(() => {
        const index = this._notificationIndexById(expiredNotification.id);
        if (index > -1) {
          this.notifications.splice(index, 1);
          this.$interval.cancel(timer);
          timer = null;
        }
      }, this.notificationsExpirationDelayTime);
    }
  }
  openAlert(alertInfo) {
    this.showAlert = true;
    this.alertInfo = alertInfo;
  }
  closeAlert() {
    this.alertInfo.deferred.resolve();
    this.showAlert = false;
    this.alertInfo = {};
  }
  openConfirm(confirmInfo) {
    this.showConfirm = true;
    this.confirmInfo = confirmInfo;
  }
  handleConfirm(value) {
    this.confirmInfo.deferred.resolve(value);
    this.showConfirm = false;
    this.confirmInfo = {};
  }
  _notificationById(id) {
    return this.notifications[this._notificationIndexById(id)];
  }
  _notificationIndexById(id) {
    return this.notifications.findIndex((notification) => notification.id === id);
  }
}

export default {
  controller: UIMessagesContainer,
  template: `
    <uimessages
      notifications="$ctrl.notifications"
      on-notification-close-request="$ctrl.closeNotification(notification)"

      show-alert="$ctrl.showAlert"
      alert-info="$ctrl.alertInfo"
      on-alert-action="$ctrl.closeAlert()"

      show-confirm="$ctrl.showConfirm"
      confirm-info="$ctrl.confirmInfo"
      on-confirm-action="$ctrl.handleConfirm(value)"
    ></uimessages>
  `,
};
